import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./routes/AppRouter";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { store } from "./data/redux/store";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/reset.css";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "./theme/bootstrap-theme.css";
import "./theme/component-color.css";
// import "antd/dist/antd.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <Toaster position="top-right" />
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  </Provider>
);
